// extracted by mini-css-extract-plugin
export default {"gearCheck":"OrgsOrdersGear_gearCheck__VqWfb","gearHeader":"OrgsOrdersGear_gearHeader__gPdGP","placeHolderShimmer":"OrgsOrdersGear_placeHolderShimmer__Hit1G"};